/**
 * Les cinq morceaux les plus joués dans chaque catégorie.
 *
 * Un tableau et non un graphique : sept catégories × cinq morceaux, ce sont
 * trente-cinq libellés longs. Aucune forme graphique ne les porterait sans les
 * tronquer, et la question posée ici — « qu'est-ce qui marche dans chaque
 * genre ? » — se lit très bien en liste.
 */

import { formatInteger } from '../lib/format';
import { COLORS } from '../lib/theme';
import type { CategoryTopTrack } from '../types';
import { Card } from './Card';

export function TopByCategoryTable({ data }: { data: readonly CategoryTopTrack[] }) {
  if (data.length === 0) {
    return (
      <Card title="Top 5 par catégorie" className="chart-grid__wide">
        <p className="empty" style={{ height: 120 }}>
          Aucun morceau joué sur cette période.
        </p>
      </Card>
    );
  }

  // Regroupement par categorie en conservant l'ordre d'arrivee : l'API trie
  // deja par categorie puis par rang.
  const groups = new Map<number, { label: string; tracks: CategoryTopTrack[] }>();
  for (const track of data) {
    const group = groups.get(track.categoryId);
    if (group) group.tracks.push(track);
    else groups.set(track.categoryId, { label: track.categoryLabel, tracks: [track] });
  }

  return (
    <Card
      title="Top 5 par catégorie"
      subtitle="Écoutes et apprentissages confondus — survoler pour le nom de fichier"
      className="chart-grid__wide"
    >
      <div className="category-grid">
        {[...groups.entries()].map(([categoryId, group]) => (
          <div key={categoryId}>
            <h3 className="category-grid__title">{group.label}</h3>
            <table className="data">
              <tbody>
                {group.tracks.map((track) => (
                  <tr key={track.trackName}>
                    <td className="num" style={{ width: 28, color: COLORS.textMuted }}>
                      {track.rank}
                    </td>
                    <td className="wrap" title={track.trackName}>
                      {track.label}
                    </td>
                    <td className="num">{formatInteger(track.actions)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </Card>
  );
}
